import React from "react";
import "./index.scss";

const CarouselDots = () => <div className="slick-dots__item"></div>;

export default CarouselDots;
